<img [src]="imageToShow">